module.exports = __webpack_public_path__ + "static/img/200091.9fd53985.png";